// Shared helpers for template sections

export const emptyButton = () => ({ text: "", url: "", newTab: false });

export const emptyBg = () => ({ bgImageAlt: "", bgVideoUrl: "", overlayOpacity: 0 });

export const moveItem = (arr, from, to) => {
  const a = [...arr];
  const [item] = a.splice(from, 1);
  a.splice(to, 0, item);
  return a;
};
